export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.zy-crm.lead.title': 'Lead List',
  'pages.zy-crm.customer.title': 'Customer List',
  'pages.zy-crm.contact.title': 'Contact List',
  'pages.zy-crm.contact.detailTitle': 'Contact Detail',
  'pages.zy-crm.common.confirmDelete': 'Confirm Deletion',
  'pages.zy-crm.common.confirmDeleteContent':
    'This action cannot be undone. Please proceed with caution.',
  'pages.zy-crm.common.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.common.updateSuccess': 'Updated successfully',
  'pages.zy-crm.common.createSuccess': 'Created successfully',
  'pages.zy-crm.common.operation': 'Operation',
  'pages.zy-crm.common.detail': 'Detail',
  'pages.zy-crm.common.edit': 'Edit',
  'pages.zy-crm.common.delete': 'Delete',
  'pages.zy-crm.common.refresh': 'Refresh',
  'pages.zy-crm.common.create': 'Create',
  'pages.zy-crm.common.detailLoadFailed': 'Failed to load details',
  'pages.zy-crm.common.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.common.noDetailData': 'No detail data found',
  'pages.zy-crm.common.id': 'ID',
  'pages.zy-crm.common.relatedData': 'Related Data',
  'pages.zy-crm.common.relatedDataTodo':
    'Related data can be extended via business APIs',
  'pages.zy-crm.common.required': 'Required field',
  'pages.zy-crm.common.yes': 'Yes',
  'pages.zy-crm.common.no': 'No',
  'pages.zy-crm.opportunityPipelines.title':
    'Opportunity Pipeline Configuration',
  'pages.zy-crm.opportunityStages.title': 'Opportunity Stage Configuration',
  'pages.zy-crm.areas.title': 'Area Configuration',
  'pages.zy-crm.industries.title': 'Industry Configuration',
  'pages.zy-crm.productCategories.title': 'Product Category Configuration',
  'pages.zy-crm.sourceChannels.title': 'Source Channel Configuration',
  'pages.zy-crm.dictionary.column.id': 'ID',
  'pages.zy-crm.dictionary.column.uuid': 'Identifier',
  'pages.zy-crm.dictionary.column.name': 'Name',
  'pages.zy-crm.dictionary.column.updateTime': 'Update Time',
  'pages.zy-crm.dictionary.confirmDeleteOne':
    'Are you sure you want to delete this record?',
  'pages.zy-crm.dictionary.modal.editTitle': 'Edit {title}',
  'pages.zy-crm.dictionary.modal.createTitle': 'Create {title}',
  'pages.zy-crm.dictionary.validation.nameRequired': 'Name is required',
  'pages.zy-crm.dictionary.validation.enterName': 'Please enter name',
  'pages.zy-crm.dictionary.field.name': 'Name',
  'pages.zy-crm.dictionary.field.uuidOptional': 'Identifier (System Generated)',
  'pages.zy-crm.dictionary.field.uuidHint':
    'Generated by the system automatically; no manual input needed',
  'pages.zy-crm.dictionaryManagement.field.type': 'Dictionary Type',
  'pages.zy-crm.contact.management': 'Contact Management',
  'pages.zy-crm.contact.unknownMember': 'Unknown member',
  'pages.zy-crm.contact.memberLoadFailed':
    'Failed to load members. Please try again later.',
  'pages.zy-crm.contact.memberLoadFailedSubmit':
    'Failed to load members. Cannot submit now, please retry.',
  'pages.zy-crm.contact.field.name': 'Contact Name',
  'pages.zy-crm.contact.field.customer': 'Customer',
  'pages.zy-crm.contact.field.lastContactTime': 'Last Contact Time',
  'pages.zy-crm.contact.field.lastContactContent': 'Last Contact Content',
  'pages.zy-crm.contact.field.nextContactTime': 'Next Contact Time',
  'pages.zy-crm.contact.field.owner': 'Owner',
  'pages.zy-crm.contact.field.mobile': 'Mobile',
  'pages.zy-crm.contact.field.telephone': 'Telephone',
  'pages.zy-crm.contact.field.email': 'Email',
  'pages.zy-crm.contact.field.qq': 'QQ',
  'pages.zy-crm.contact.field.wechat': 'WeChat',
  'pages.zy-crm.contact.field.area': 'Area',
  'pages.zy-crm.contact.field.parent': 'Parent Contact',
  'pages.zy-crm.contact.field.detailAddress': 'Detailed Address',
  'pages.zy-crm.contact.field.remark': 'Remark',
  'pages.zy-crm.contact.field.post': 'Position',
  'pages.zy-crm.contact.field.sex': 'Gender',
  'pages.zy-crm.contact.field.isPrimaryDecisionMaker': 'Primary Decision Maker',
  'pages.zy-crm.contact.placeholder.name': 'Please enter contact name',
  'pages.zy-crm.contact.placeholder.lastContactContent':
    'Please enter last contact content',
  'pages.zy-crm.contact.placeholder.lastContactTime':
    'Please select last contact time',
  'pages.zy-crm.contact.placeholder.nextContactTime':
    'Please select next contact time',
  'pages.zy-crm.contact.placeholder.email': 'Please enter email',
  'pages.zy-crm.contact.placeholder.mobile': 'Please enter mobile',
  'pages.zy-crm.contact.placeholder.qq': 'Please enter QQ',
  'pages.zy-crm.contact.placeholder.telephone': 'Please enter telephone',
  'pages.zy-crm.contact.placeholder.wechat': 'Please enter WeChat',
  'pages.zy-crm.contact.placeholder.area': 'Please enter area ID',
  'pages.zy-crm.contact.placeholder.customer': 'Please enter customer ID',
  'pages.zy-crm.contact.placeholder.owner': 'Please select owner',
  'pages.zy-crm.contact.placeholder.parent': 'Please enter parent contact ID',
  'pages.zy-crm.contact.placeholder.detailAddress':
    'Please enter detailed address',
  'pages.zy-crm.contact.placeholder.remark': 'Please enter remark',
  'pages.zy-crm.contact.placeholder.isPrimaryDecisionMaker':
    'Please select whether this is a primary decision maker',
  'pages.zy-crm.contact.placeholder.post': 'Please enter position',
  'pages.zy-crm.contact.placeholder.sex': 'Please enter gender code',
  'pages.zy-crm.contact.section.basic': 'Basic Information',
  'pages.zy-crm.contact.section.followUp': 'Follow-up Information',
  'pages.zy-crm.contact.section.contact': 'Contact Information',
  'pages.zy-crm.contact.section.relation': 'Relation Information',
  'pages.zy-crm.contact.section.remark': 'Remarks',
  'pages.zy-crm.contact.section.other': 'Other Information',
  'pages.zy-crm.opportunity.title': 'Opportunity List',
  'pages.zy-crm.opportunity.detailTitle': 'Opportunity Detail',
  'pages.zy-crm.opportunity.card.manageTitle': 'Opportunity Management',
  'pages.zy-crm.opportunity.action.refresh': 'Refresh',
  'pages.zy-crm.opportunity.action.create': 'New',
  'pages.zy-crm.opportunity.action.detail': 'Detail',
  'pages.zy-crm.opportunity.action.edit': 'Edit',
  'pages.zy-crm.opportunity.action.delete': 'Delete',
  'pages.zy-crm.opportunity.column.operation': 'Actions',
  'pages.zy-crm.opportunity.modal.createTitle': 'Create',
  'pages.zy-crm.opportunity.modal.editTitle': 'Edit',
  'pages.zy-crm.opportunity.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.opportunity.modal.deleteContent':
    'This action cannot be undone.',
  'pages.zy-crm.opportunity.form.required': 'Required field',
  'pages.zy-crm.opportunity.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.opportunity.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.opportunity.form.placeholder.relation':
    'Please enter related {label}',
  'pages.zy-crm.opportunity.form.bool.yes': 'Yes',
  'pages.zy-crm.opportunity.form.bool.no': 'No',
  'pages.zy-crm.opportunity.form.group.basic': 'Basic Information',
  'pages.zy-crm.opportunity.form.group.followup': 'Follow-up Information',
  'pages.zy-crm.opportunity.form.group.contact': 'Contact Information',
  'pages.zy-crm.opportunity.form.group.business': 'Business Information',
  'pages.zy-crm.opportunity.form.group.relation': 'Relation Information',
  'pages.zy-crm.opportunity.form.group.detail': 'Remarks',
  'pages.zy-crm.opportunity.form.group.other': 'Other Information',
  'pages.zy-crm.opportunity.message.createSuccess': 'Created successfully',
  'pages.zy-crm.opportunity.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.opportunity.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.opportunity.message.noCreateApi':
    'Create API is not provided by backend',
  'pages.zy-crm.opportunity.message.noUpdateApi':
    'Update API is not provided by backend',
  'pages.zy-crm.opportunity.message.noDeleteApi':
    'Delete API is not provided by backend',
  'pages.zy-crm.opportunity.message.memberLoadFailed':
    'Failed to load members, please try again later',
  'pages.zy-crm.opportunity.message.memberLoadBlocked':
    'Failed to load members, cannot submit now',
  'pages.zy-crm.opportunity.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.opportunity.member.unknown': 'Unknown member',
  'pages.zy-crm.opportunity.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.opportunity.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.opportunity.state.relationDataEmpty':
    'Related data can be added by business APIs',
  'pages.zy-crm.opportunity.card.relation': 'Related Data',
  'pages.zy-crm.opportunity.field.id': 'ID',
  'pages.zy-crm.opportunity.field.name': 'Opportunity Name',
  'pages.zy-crm.opportunity.field.customer': 'Customer',
  'pages.zy-crm.opportunity.field.followUpStatus': 'Follow-up Status',
  'pages.zy-crm.opportunity.field.contactLastTime': 'Last Contact Time',
  'pages.zy-crm.opportunity.field.contactNextTime': 'Next Contact Time',
  'pages.zy-crm.opportunity.field.ownerUser': 'Owner',
  'pages.zy-crm.opportunity.field.pipeline': 'Pipeline',
  'pages.zy-crm.opportunity.field.stage': 'Stage',
  'pages.zy-crm.opportunity.field.endStatus': 'End Status',
  'pages.zy-crm.opportunity.field.dealTime': 'Deal Time',
  'pages.zy-crm.opportunity.field.totalProductPrice': 'Total Product Price',
  'pages.zy-crm.opportunity.field.discountPercent': 'Discount Percent',
  'pages.zy-crm.opportunity.field.totalPrice': 'Total Price',
  'pages.zy-crm.opportunity.field.remark': 'Remark',
  'pages.zy-crm.opportunity.field.endRemark': 'End Remark',
  'pages.zy-crm.product.title': 'Product List',
  'pages.zy-crm.product.detailTitle': 'Product Detail',
  'pages.zy-crm.product.card.manageTitle': 'Product Management',
  'pages.zy-crm.product.field.name': 'Name',
  'pages.zy-crm.product.field.code': 'Code',
  'pages.zy-crm.product.field.unit': 'Product Unit',
  'pages.zy-crm.product.field.price': 'Price',
  'pages.zy-crm.product.field.costPrice': 'Cost Price',
  'pages.zy-crm.product.field.status': 'Shelf Status',
  'pages.zy-crm.product.field.category': 'Product Type',
  'pages.zy-crm.product.field.description': 'Product Description',
  'pages.zy-crm.product.field.mainImage': 'Main Image',
  'pages.zy-crm.product.field.detailImages': 'Detail Images',
  'pages.zy-crm.product.field.owner': 'Owner',
  'pages.zy-crm.product.action.refresh': 'Refresh',
  'pages.zy-crm.product.action.create': 'New',
  'pages.zy-crm.product.action.detail': 'Detail',
  'pages.zy-crm.product.action.edit': 'Edit',
  'pages.zy-crm.product.action.delete': 'Delete',
  'pages.zy-crm.product.column.operation': 'Actions',
  'pages.zy-crm.product.modal.createTitle': 'Create Product',
  'pages.zy-crm.product.modal.editTitle': 'Edit Product',
  'pages.zy-crm.product.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.product.modal.deleteContent': 'This action cannot be undone.',
  'pages.zy-crm.product.form.required': 'Required field',
  'pages.zy-crm.product.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.product.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.product.form.placeholder.relation':
    'Please enter related {label}',
  'pages.zy-crm.product.form.bool.yes': 'Yes',
  'pages.zy-crm.product.form.bool.no': 'No',
  'pages.zy-crm.product.form.group.basic': 'Basic Information',
  'pages.zy-crm.product.form.group.followup': 'Follow-up Information',
  'pages.zy-crm.product.form.group.contact': 'Contact Information',
  'pages.zy-crm.product.form.group.business': 'Business Information',
  'pages.zy-crm.product.form.group.relation': 'Relation Information',
  'pages.zy-crm.product.form.group.detail': 'Remarks',
  'pages.zy-crm.product.form.group.other': 'Other Information',
  'pages.zy-crm.product.form.autoCodeHint': 'Auto-generated by numbering rule',
  'pages.zy-crm.product.enum.status.enabled': 'Enabled / On Sale',
  'pages.zy-crm.product.enum.status.disabled': 'Disabled / Off Shelf',
  'pages.zy-crm.product.message.createSuccess': 'Created successfully',
  'pages.zy-crm.product.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.product.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.product.message.noCreateApi':
    'Create API is not provided by backend',
  'pages.zy-crm.product.message.noUpdateApi':
    'Update API is not provided by backend',
  'pages.zy-crm.product.message.noDeleteApi':
    'Delete API is not provided by backend',
  'pages.zy-crm.product.message.memberLoadFailed':
    'Failed to load members, please try again later',
  'pages.zy-crm.product.message.memberLoadBlocked':
    'Failed to load members, cannot submit now',
  'pages.zy-crm.product.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.product.member.unknown': 'Unknown member',
  'pages.zy-crm.product.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.product.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.product.state.relationDataEmpty':
    'Related data can be added by business APIs',
  'pages.zy-crm.product.card.relation': 'Related Data',
  'pages.zy-crm.contract.title': 'Contract List',
  'pages.zy-crm.contract.detailTitle': 'Contract Detail',
  'pages.zy-crm.contract.card.manageTitle': 'Contract Management',
  'pages.zy-crm.contract.action.refresh': 'Refresh',
  'pages.zy-crm.contract.action.create': 'New',
  'pages.zy-crm.contract.action.detail': 'Detail',
  'pages.zy-crm.contract.action.edit': 'Edit',
  'pages.zy-crm.contract.action.delete': 'Delete',
  'pages.zy-crm.contract.column.operation': 'Actions',
  'pages.zy-crm.contract.modal.createTitle': 'Create',
  'pages.zy-crm.contract.modal.editTitle': 'Edit',
  'pages.zy-crm.contract.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.contract.modal.deleteContent': 'This action cannot be undone.',
  'pages.zy-crm.contract.form.required': 'Required field',
  'pages.zy-crm.contract.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.contract.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.contract.form.placeholder.relation':
    'Please enter related {label}',
  'pages.zy-crm.contract.form.bool.yes': 'Yes',
  'pages.zy-crm.contract.form.bool.no': 'No',
  'pages.zy-crm.contract.form.group.basic': 'Basic Information',
  'pages.zy-crm.contract.form.group.followup': 'Follow-up Information',
  'pages.zy-crm.contract.form.group.contact': 'Contact Information',
  'pages.zy-crm.contract.form.group.business': 'Business Information',
  'pages.zy-crm.contract.form.group.relation': 'Relation Information',
  'pages.zy-crm.contract.form.group.sign': 'Signing Information',
  'pages.zy-crm.contract.form.group.product': 'Product Information',
  'pages.zy-crm.contract.form.group.amount': 'Amount Summary',
  'pages.zy-crm.contract.form.group.detail': 'Remarks',
  'pages.zy-crm.contract.form.group.other': 'Other Information',
  'pages.zy-crm.contract.form.autoCodeHint': 'Auto-generated by numbering rule',
  'pages.zy-crm.contract.message.createSuccess': 'Created successfully',
  'pages.zy-crm.contract.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.contract.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.contract.message.noCreateApi':
    'Create API is not provided by backend',
  'pages.zy-crm.contract.message.noUpdateApi':
    'Update API is not provided by backend',
  'pages.zy-crm.contract.message.noDeleteApi':
    'Delete API is not provided by backend',
  'pages.zy-crm.contract.message.memberLoadFailed':
    'Failed to load members, please try again later',
  'pages.zy-crm.contract.message.customerLoadFailed':
    'Failed to load customers, please try again later',
  'pages.zy-crm.contract.message.opportunityLoadFailed':
    'Failed to load opportunities, please try again later',
  'pages.zy-crm.contract.message.memberLoadBlocked':
    'Failed to load members, cannot submit now',
  'pages.zy-crm.contract.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.contract.message.loadDetailFailed':
    'Failed to load contract detail',
  'pages.zy-crm.contract.message.productEmpty':
    'Please add at least one product row',
  'pages.zy-crm.contract.member.unknown': 'Unknown member',
  'pages.zy-crm.contract.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.contract.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.contract.state.relationDataEmpty':
    'Related data can be added by business APIs',
  'pages.zy-crm.contract.card.relation': 'Related Data',
  'pages.zy-crm.contract.card.productDetail': 'Product Details',
  'pages.zy-crm.contract.search.expand': 'Expand',
  'pages.zy-crm.contract.search.collapse': 'Collapse',
  'pages.zy-crm.contract.enum.type.standard': 'Standard Contract',
  'pages.zy-crm.contract.enum.type.framework': 'Framework Contract',
  'pages.zy-crm.contract.enum.type.supplement': 'Supplemental Agreement',
  'pages.zy-crm.contract.action.addProduct': 'Add Product',
  'pages.zy-crm.contract.action.addRow': 'Add Row',
  'pages.zy-crm.contract.table.emptyProducts': 'No product details',
  'pages.zy-crm.contract.field.id': 'ID',
  'pages.zy-crm.contract.field.name': 'Name',
  'pages.zy-crm.contract.field.code': 'Contract Code',
  'pages.zy-crm.contract.field.customer': 'Customer',
  'pages.zy-crm.contract.field.opportunity': 'Opportunity',
  'pages.zy-crm.contract.field.contactLastTime': 'Last Contact Time',
  'pages.zy-crm.contract.field.ownerUser': 'Owner',
  'pages.zy-crm.contract.field.processInstance': 'Process Instance',
  'pages.zy-crm.contract.field.auditStatus': 'Approval Status',
  'pages.zy-crm.contract.field.orderDate': 'Order Date',
  'pages.zy-crm.contract.field.startTime': 'Start Time',
  'pages.zy-crm.contract.field.endTime': 'End Time',
  'pages.zy-crm.contract.field.contractType': 'Contract Type',
  'pages.zy-crm.contract.field.customerSigner': 'Customer Signer',
  'pages.zy-crm.contract.field.companySignerUserUuid': 'Company Signer',
  'pages.zy-crm.contract.field.signContactUuid': 'Signing Contact',
  'pages.zy-crm.contract.field.signUserUuid': 'Signer',
  'pages.zy-crm.contract.field.contractImageUrl': 'Contract Image URL',
  'pages.zy-crm.contract.field.totalProductPrice': 'Total Product Price',
  'pages.zy-crm.contract.field.discountPercent': 'Discount Percent',
  'pages.zy-crm.contract.field.totalPrice': 'Total Contract Price',
  'pages.zy-crm.contract.field.profitAmount': 'Profit',
  'pages.zy-crm.contract.field.productName': 'Product Name',
  'pages.zy-crm.contract.field.productType': 'Product Type',
  'pages.zy-crm.contract.field.productUnit': 'Product Unit',
  'pages.zy-crm.contract.field.listPrice': 'List Price',
  'pages.zy-crm.contract.field.costPrice': 'Cost Price',
  'pages.zy-crm.contract.field.salePrice': 'Sale Price',
  'pages.zy-crm.contract.field.quantity': 'Quantity',
  'pages.zy-crm.contract.field.lineTotal': 'Line Total',
  'pages.zy-crm.contract.field.signContact': 'Sign Contact',
  'pages.zy-crm.contract.field.signUser': 'Signer',
  'pages.zy-crm.contract.field.remark': 'Remark',
  'pages.zy-crm.contract.field.customerUuid': 'Customer',
  'pages.zy-crm.contract.field.opportunityUuid': 'Opportunity',
  'pages.zy-crm.contract.field.ownerUserUuid': 'Owner',
  'pages.zy-crm.contract.field.processInstanceUuid': 'Process Instance',
  'pages.zy-crm.contractCodeRule.title': 'Contract Code Rules',
  'pages.zy-crm.contractCodeRule.cardTitle': 'Contract Code Rules',
  'pages.zy-crm.contractCodeRule.action.save': 'Save',
  'pages.zy-crm.contractCodeRule.action.reset': 'Reset',
  'pages.zy-crm.contractCodeRule.message.saveSuccess':
    'Contract code rule saved successfully',
  'pages.zy-crm.contractCodeRule.message.loadFailed':
    'Failed to load contract code rule',
  'pages.zy-crm.contractCodeRule.message.saveFailed':
    'Failed to save contract code rule',
  'pages.zy-crm.contractCodeRule.form.required': 'Required',
  'pages.zy-crm.contractCodeRule.field.prefix': 'Code Prefix',
  'pages.zy-crm.contractCodeRule.field.dateFormat': 'Date Format',
  'pages.zy-crm.contractCodeRule.field.seqLength': 'Sequence Length',
  'pages.zy-crm.contractCodeRule.field.resetCycle': 'Reset Cycle',
  'pages.zy-crm.contractCodeRule.preview.label': 'Next Code Preview',
  'pages.zy-crm.contractCodeRule.enum.date.none': 'No Date',
  'pages.zy-crm.contractCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.contractCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.contractCodeRule.enum.cycle.none': 'No Reset',
  'pages.zy-crm.contractCodeRule.enum.cycle.year': 'Reset by Year',
  'pages.zy-crm.contractCodeRule.enum.cycle.month': 'Reset by Month',
  'pages.zy-crm.productCodeRule.title': 'Product Code Rules',
  'pages.zy-crm.productCodeRule.cardTitle': 'Product Code Rules',
  'pages.zy-crm.productCodeRule.action.save': 'Save',
  'pages.zy-crm.productCodeRule.action.reset': 'Reset',
  'pages.zy-crm.productCodeRule.message.saveSuccess':
    'Product code rule saved successfully',
  'pages.zy-crm.productCodeRule.message.loadFailed':
    'Failed to load product code rules',
  'pages.zy-crm.productCodeRule.message.saveFailed':
    'Failed to save product code rules',
  'pages.zy-crm.productCodeRule.form.required': 'Required',
  'pages.zy-crm.productCodeRule.field.prefix': 'Code Prefix',
  'pages.zy-crm.productCodeRule.field.dateFormat': 'Date Format',
  'pages.zy-crm.productCodeRule.field.seqLength': 'Sequence Length',
  'pages.zy-crm.productCodeRule.field.resetCycle': 'Reset Cycle',
  'pages.zy-crm.productCodeRule.preview.label': 'Next Code Preview',
  'pages.zy-crm.productCodeRule.enum.date.none': 'No Date',
  'pages.zy-crm.productCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.productCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.productCodeRule.enum.cycle.none': 'No Reset',
  'pages.zy-crm.productCodeRule.enum.cycle.year': 'Reset by Year',
  'pages.zy-crm.productCodeRule.enum.cycle.month': 'Reset by Month',
  'pages.zy-crm.receipt.title': 'Receipt List',
  'pages.zy-crm.receipt.card.manageTitle': 'Receipt Management',
  'pages.zy-crm.receipt.action.refresh': 'Refresh',
  'pages.zy-crm.receipt.action.create': 'New',
  'pages.zy-crm.receipt.action.detail': 'Detail',
  'pages.zy-crm.receipt.action.edit': 'Edit',
  'pages.zy-crm.receipt.action.delete': 'Delete',
  'pages.zy-crm.receipt.column.operation': 'Actions',
  'pages.zy-crm.receipt.modal.createTitle': 'Create',
  'pages.zy-crm.receipt.modal.editTitle': 'Edit',
  'pages.zy-crm.receipt.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.receipt.modal.deleteContent': 'This action cannot be undone.',
  'pages.zy-crm.receipt.form.required': 'Required field',
  'pages.zy-crm.receipt.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.receipt.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.receipt.form.placeholder.relation':
    'Please enter related {label}',
  'pages.zy-crm.receipt.form.bool.yes': 'Yes',
  'pages.zy-crm.receipt.form.bool.no': 'No',
  'pages.zy-crm.receipt.form.group.basic': 'Basic Information',
  'pages.zy-crm.receipt.form.group.followup': 'Follow-up Information',
  'pages.zy-crm.receipt.form.group.contact': 'Contact Information',
  'pages.zy-crm.receipt.form.group.business': 'Business Information',
  'pages.zy-crm.receipt.form.group.relation': 'Relation Information',
  'pages.zy-crm.receipt.form.group.detail': 'Remarks',
  'pages.zy-crm.receipt.form.group.other': 'Other Information',
  'pages.zy-crm.receipt.message.createSuccess': 'Created successfully',
  'pages.zy-crm.receipt.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.receipt.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.receipt.message.noCreateApi':
    'Create API is not provided by backend',
  'pages.zy-crm.receipt.message.noUpdateApi':
    'Update API is not provided by backend',
  'pages.zy-crm.receipt.message.noDeleteApi':
    'Delete API is not provided by backend',
  'pages.zy-crm.receipt.message.memberLoadFailed':
    'Failed to load members, please try again later',
  'pages.zy-crm.receipt.message.memberLoadBlocked':
    'Failed to load members, cannot submit now',
  'pages.zy-crm.receipt.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.receipt.member.unknown': 'Unknown member',
  'pages.zy-crm.receipt.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.receipt.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.receipt.state.relationDataEmpty':
    'Related data can be added by business APIs',
  'pages.zy-crm.receipt.card.relation': 'Related Data',
  'pages.zy-crm.receipt.search.expand': 'Expand',
  'pages.zy-crm.receipt.search.collapse': 'Collapse',
  'pages.zy-crm.receipt.field.id': 'Id',
  'pages.zy-crm.receipt.field.code': 'Code',
  'pages.zy-crm.receipt.field.receiptScheduleUuid': 'Receipt Schedule',
  'pages.zy-crm.receipt.field.customerUuid': 'Customer',
  'pages.zy-crm.receipt.field.contractUuid': 'Contract',
  'pages.zy-crm.receipt.field.ownerUserUuid': 'Owner User',
  'pages.zy-crm.receipt.field.auditStatus': 'Audit Status',
  'pages.zy-crm.receipt.field.processInstanceUuid': 'Process Instance',
  'pages.zy-crm.receipt.field.receiptDate': 'Receipt Date',
  'pages.zy-crm.receipt.field.receiptMethod': 'Receipt Method',
  'pages.zy-crm.receipt.field.price': 'Price',
  'pages.zy-crm.receipt.field.remark': 'Remark',
  'pages.zy-crm.receipt.placeholder.autoCode':
    'Generated automatically by system rules',
  'pages.zy-crm.receipt-schedule.title': 'ReceiptSchedule List',
  'pages.zy-crm.receipt-schedule.detailTitle': 'ReceiptSchedule Detail',
  'pages.zy-crm.receipt-schedule.card.manageTitle':
    'ReceiptSchedule Management',
  'pages.zy-crm.receipt-schedule.action.refresh': 'Refresh',
  'pages.zy-crm.receipt-schedule.action.create': 'New',
  'pages.zy-crm.receipt-schedule.action.detail': 'Detail',
  'pages.zy-crm.receipt-schedule.action.edit': 'Edit',
  'pages.zy-crm.receipt-schedule.action.delete': 'Delete',
  'pages.zy-crm.receipt-schedule.column.operation': 'Actions',
  'pages.zy-crm.receipt-schedule.modal.createTitle': 'Create',
  'pages.zy-crm.receipt-schedule.modal.editTitle': 'Edit',
  'pages.zy-crm.receipt-schedule.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.receipt-schedule.modal.deleteContent':
    'This action cannot be undone.',
  'pages.zy-crm.receipt-schedule.form.required': 'Required field',
  'pages.zy-crm.receipt-schedule.form.placeholder.input':
    'Please enter {label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.select':
    'Please select {label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.relation':
    'Please enter related {label}',
  'pages.zy-crm.receipt-schedule.form.bool.yes': 'Yes',
  'pages.zy-crm.receipt-schedule.form.bool.no': 'No',
  'pages.zy-crm.receipt-schedule.form.group.basic': 'Basic Information',
  'pages.zy-crm.receipt-schedule.form.group.followup': 'Follow-up Information',
  'pages.zy-crm.receipt-schedule.form.group.contact': 'Contact Information',
  'pages.zy-crm.receipt-schedule.form.group.business': 'Business Information',
  'pages.zy-crm.receipt-schedule.form.group.relation': 'Relation Information',
  'pages.zy-crm.receipt-schedule.form.group.detail': 'Remarks',
  'pages.zy-crm.receipt-schedule.form.group.other': 'Other Information',
  'pages.zy-crm.receipt-schedule.message.createSuccess': 'Created successfully',
  'pages.zy-crm.receipt-schedule.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.receipt-schedule.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.receipt-schedule.message.noCreateApi':
    'Create API is not provided by backend',
  'pages.zy-crm.receipt-schedule.message.noUpdateApi':
    'Update API is not provided by backend',
  'pages.zy-crm.receipt-schedule.message.noDeleteApi':
    'Delete API is not provided by backend',
  'pages.zy-crm.receipt-schedule.message.memberLoadFailed':
    'Failed to load members, please try again later',
  'pages.zy-crm.receipt-schedule.message.memberLoadBlocked':
    'Failed to load members, cannot submit now',
  'pages.zy-crm.receipt-schedule.message.detailLoadFailed':
    'Failed to load detail',
  'pages.zy-crm.receipt-schedule.member.unknown': 'Unknown member',
  'pages.zy-crm.receipt-schedule.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.receipt-schedule.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.receipt-schedule.state.relationDataEmpty':
    'Related data can be added by business APIs',
  'pages.zy-crm.receipt-schedule.card.relation': 'Related Data',
  'pages.zy-crm.receipt-schedule.search.expand': 'Expand',
  'pages.zy-crm.receipt-schedule.search.collapse': 'Collapse',
  'pages.zy-crm.receipt-schedule.field.id': 'Id',
  'pages.zy-crm.receipt-schedule.field.period': 'Period',
  'pages.zy-crm.receipt-schedule.field.customerUuid': 'Customer',
  'pages.zy-crm.receipt-schedule.field.contractUuid': 'Contract',
  'pages.zy-crm.receipt-schedule.field.ownerUserUuid': 'Owner User',
  'pages.zy-crm.receipt-schedule.field.receiptUuid': 'Receipt',
  'pages.zy-crm.receipt-schedule.field.receiptDate': 'Receipt Date',
  'pages.zy-crm.receipt-schedule.field.receiptMethod': 'Receipt Method',
  'pages.zy-crm.receipt-schedule.field.price': 'Price',
  'pages.zy-crm.receipt-schedule.field.receivedAmount': 'Received Amount',
  'pages.zy-crm.receipt-schedule.field.unpaidAmount': 'Unpaid Amount',
  'pages.zy-crm.receipt-schedule.field.remindDays': 'Remind Days',
  'pages.zy-crm.receipt-schedule.field.remindTime': 'Remind Time',
  'pages.zy-crm.receipt-schedule.field.status': 'Status',
  'pages.zy-crm.receipt-schedule.field.systemStatus': 'System Status',
  'pages.zy-crm.receipt-schedule.field.remark': 'Remark',
  'pages.zy-crm.receipt.option.receiptMethod.bankTransfer': 'Bank Transfer',
  'pages.zy-crm.receipt.option.receiptMethod.cash': 'Cash',
  'pages.zy-crm.receipt.option.receiptMethod.check': 'Check',
  'pages.zy-crm.receipt.option.receiptMethod.other': 'Other',
  'pages.zy-crm.receipt.option.status.draft': 'Draft',
  'pages.zy-crm.receipt.option.status.pending': 'Pending Approval',
  'pages.zy-crm.receipt.option.status.approved': 'Approved',
  'pages.zy-crm.receipt.option.status.rejected': 'Rejected',
  'pages.zy-crm.receipt-schedule.option.status.pending': 'Pending',
  'pages.zy-crm.receipt-schedule.option.status.completed': 'Completed',
  'pages.zy-crm.calendar.title': 'Calendar',
  'pages.zy-crm.calendar.action.today': 'Today',
  'pages.zy-crm.calendar.action.prev': 'Previous',
  'pages.zy-crm.calendar.action.next': 'Next',
  'pages.zy-crm.calendar.action.create': 'Create',
  'pages.zy-crm.calendar.action.refresh': 'Refresh',
  'pages.zy-crm.calendar.action.save': 'Save',
  'pages.zy-crm.calendar.action.delete': 'Delete',
  'pages.zy-crm.calendar.action.openSource': 'Open Source Record',
  'pages.zy-crm.calendar.view.day': 'Day',
  'pages.zy-crm.calendar.view.week': 'Week',
  'pages.zy-crm.calendar.view.month': 'Month',
  'pages.zy-crm.calendar.view.list': 'List',
  'pages.zy-crm.calendar.sidebar.mySchedule': 'My Schedules',
  'pages.zy-crm.calendar.sidebar.systemType': 'Activity Type',
  'pages.zy-crm.calendar.sidebar.otherCalendar': 'Other Calendars',
  'pages.zy-crm.calendar.filter.my_schedule': 'My Schedule',
  'pages.zy-crm.calendar.filter.assigned_task': 'Assigned Tasks',
  'pages.zy-crm.calendar.filter.phone_communication': 'Phone Calls',
  'pages.zy-crm.calendar.filter.send_email': 'Emails',
  'pages.zy-crm.calendar.filter.online_meeting': 'Online Meetings',
  'pages.zy-crm.calendar.filter.visit': 'Visits',
  'pages.zy-crm.calendar.filter.send_sms': 'SMS',
  'pages.zy-crm.calendar.filter.lead_follow_up': 'Lead Follow-ups',
  'pages.zy-crm.calendar.filter.customer_follow_up': 'Customer Follow-ups',
  'pages.zy-crm.calendar.filter.contact_follow_up': 'Contact Follow-ups',
  'pages.zy-crm.calendar.filter.opportunity_follow_up':
    'Opportunity Follow-ups',
  'pages.zy-crm.calendar.filter.opportunity_deal': 'Expected Deals',
  'pages.zy-crm.calendar.filter.contract_expire': 'Expiring Contracts',
  'pages.zy-crm.calendar.filter.receipt_schedule': 'Receipt Plans',
  'pages.zy-crm.calendar.drawer.createTitle': 'Create Schedule',
  'pages.zy-crm.calendar.drawer.editTitle': 'Edit Schedule',
  'pages.zy-crm.calendar.drawer.detailTitle': 'Schedule Detail',
  'pages.zy-crm.calendar.form.title': 'Title',
  'pages.zy-crm.calendar.form.eventType': 'Type',
  'pages.zy-crm.calendar.form.startTime': 'Start Time',
  'pages.zy-crm.calendar.form.endTime': 'End Time',
  'pages.zy-crm.calendar.form.allDay': 'All Day',
  'pages.zy-crm.calendar.form.location': 'Location',
  'pages.zy-crm.calendar.form.description': 'Description',
  'pages.zy-crm.calendar.form.color': 'Color',
  'pages.zy-crm.calendar.form.placeholder.title': 'Please enter a title',
  'pages.zy-crm.calendar.form.placeholder.location': 'Please enter location',
  'pages.zy-crm.calendar.message.loadFailed': 'Failed to load calendar events',
  'pages.zy-crm.calendar.message.createSuccess': 'Schedule created',
  'pages.zy-crm.calendar.message.updateSuccess': 'Schedule updated',
  'pages.zy-crm.calendar.message.deleteSuccess': 'Schedule deleted',
  'pages.zy-crm.calendar.message.saveFailed':
    'Failed to save. Please try again later.',
  'pages.zy-crm.calendar.message.deleteFailed':
    'Failed to delete. Please try again later.',
  'pages.zy-crm.calendar.empty.noEventType':
    'Please select at least one calendar type',
  'pages.zy-crm.calendar.readonly.system': 'System events cannot be edited',
  'pages.zy-crm.quote.title': 'Quote List',
  'pages.zy-crm.quote.detailTitle': 'Quote Detail',
  'pages.zy-crm.quote.action.refresh': 'Refresh',
  'pages.zy-crm.quote.action.create': 'New',
  'pages.zy-crm.quote.action.codeRule': 'Code Rule',
  'pages.zy-crm.quote.action.detail': 'Detail',
  'pages.zy-crm.quote.action.edit': 'Edit',
  'pages.zy-crm.quote.action.delete': 'Delete',
  'pages.zy-crm.quote.action.restore': 'Restore',
  'pages.zy-crm.quote.action.reuse': 'Reuse',
  'pages.zy-crm.quote.action.history': 'View/Reuse History Quotes',
  'pages.zy-crm.quote.action.search': 'Search',
  'pages.zy-crm.quote.action.addProduct': 'Add Product',
  'pages.zy-crm.quote.action.addRow': 'Add Row',
  'pages.zy-crm.quote.action.saveCodeRule': 'Save Rule',
  'pages.zy-crm.quote.column.operation': 'Actions',
  'pages.zy-crm.quote.modal.createTitle': 'Create Quote',
  'pages.zy-crm.quote.modal.editTitle': 'Edit Quote',
  'pages.zy-crm.quote.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.quote.modal.deleteContent': 'This action cannot be undone.',
  'pages.zy-crm.quote.modal.restoreTitle': 'Restore this quote?',
  'pages.zy-crm.quote.modal.restoreContent': 'You can undo this deletion now.',
  'pages.zy-crm.quote.modal.historyTitle': 'History Quotes',
  'pages.zy-crm.quote.modal.diffTitle': 'Amount Difference Confirmation',
  'pages.zy-crm.quote.modal.diffContent':
    'The manual total differs from calculated total by {diff}. Continue?',
  'pages.zy-crm.quote.modal.crossCustomerTitle': 'Cross-customer Reuse',
  'pages.zy-crm.quote.modal.crossCustomerContent':
    'Current customer differs from historical quote customer. Continue and overwrite customer?',
  'pages.zy-crm.quote.modal.codeRuleTitle': 'Quote Code Rule',
  'pages.zy-crm.quote.form.required': 'Required field',
  'pages.zy-crm.quote.form.autoCodeHint': 'Auto-generated based on code rules',
  'pages.zy-crm.quote.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.quote.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.quote.form.group.basic': 'Basic Information',
  'pages.zy-crm.quote.form.group.relation': 'Relations',
  'pages.zy-crm.quote.form.group.date': 'Date Information',
  'pages.zy-crm.quote.form.group.product': 'Product Information',
  'pages.zy-crm.quote.form.group.amount': 'Amount Summary',
  'pages.zy-crm.quote.form.group.remark': 'Remarks',
  'pages.zy-crm.quote.message.createSuccess': 'Created successfully',
  'pages.zy-crm.quote.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.quote.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.quote.message.restoreSuccess': 'Restored successfully',
  'pages.zy-crm.quote.message.reuseSuccess':
    'Historical quote reused successfully',
  'pages.zy-crm.quote.message.memberLoadFailed':
    'Failed to load members, please retry later.',
  'pages.zy-crm.quote.message.memberLoadBlocked':
    'Failed to load members. Submission is blocked.',
  'pages.zy-crm.quote.message.customerLoadFailed':
    'Failed to load customers, please retry later.',
  'pages.zy-crm.quote.message.contactLoadFailed':
    'Failed to load contacts, please retry later.',
  'pages.zy-crm.quote.message.opportunityLoadFailed':
    'Failed to load opportunities, please retry later.',
  'pages.zy-crm.quote.message.productLoadFailed':
    'Failed to load products, please retry later.',
  'pages.zy-crm.quote.message.historyLoadFailed':
    'Failed to load history quotes',
  'pages.zy-crm.quote.message.productEmpty':
    'Please add at least one product item',
  'pages.zy-crm.quote.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.quote.message.codeRuleLoadFailed':
    'Failed to load quote code rule',
  'pages.zy-crm.quote.message.codeRuleUpdateSuccess':
    'Code rule updated successfully',
  'pages.zy-crm.quote.search.expand': 'Expand',
  'pages.zy-crm.quote.search.collapse': 'Collapse',
  'pages.zy-crm.quote.state.diffNeedsConfirm':
    'Amount difference not confirmed, submission cancelled',
  'pages.zy-crm.quote.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.quote.state.detailNotFound': 'Detail data not found',
  'pages.zy-crm.quote.history.range.lastMonth': 'Last Month',
  'pages.zy-crm.quote.history.range.halfYear': 'Last Half Year',
  'pages.zy-crm.quote.history.range.thisYear': 'This Year',
  'pages.zy-crm.quote.table.emptyProducts': 'No product items',
  'pages.zy-crm.quote.table.emptyHistory': 'No history quotes',
  'pages.zy-crm.quote.stats.selectedProducts': 'Selected products: {count}',
  'pages.zy-crm.quote.stats.quoteAmount': 'Total amount: {amount}',
  'pages.zy-crm.quote.option.dateFormat.none': 'No Date',
  'pages.zy-crm.quote.option.dateFormat.yymm': 'Year/Month (YYMM)',
  'pages.zy-crm.quote.option.dateFormat.yyyymmdd': 'Year/Month/Day (YYYYMMDD)',
  'pages.zy-crm.quote.option.resetCycle.none': 'No Reset',
  'pages.zy-crm.quote.option.resetCycle.year': 'Reset Yearly',
  'pages.zy-crm.quote.option.resetCycle.month': 'Reset Monthly',
  'pages.zy-crm.quote.status.approved': 'Approved',
  'pages.zy-crm.quote.status.submitted': 'In Review',
  'pages.zy-crm.quote.status.rejected': 'Rejected',
  'pages.zy-crm.quote.status.draft': 'Draft',
  'pages.zy-crm.quote.field.code': 'Quote Code',
  'pages.zy-crm.quote.field.name': 'Quote Name',
  'pages.zy-crm.quote.field.customerUuid': 'Customer',
  'pages.zy-crm.quote.field.contactUuid': 'Customer Contact',
  'pages.zy-crm.quote.field.opportunityUuid': 'Opportunity',
  'pages.zy-crm.quote.field.quoteDate': 'Quote Date',
  'pages.zy-crm.quote.field.expectedDealDate': 'Expected Deal Date',
  'pages.zy-crm.quote.field.ownerUserUuid': 'Owner',
  'pages.zy-crm.quote.field.ownerMobile': 'Owner Mobile',
  'pages.zy-crm.quote.field.auditStatus': 'Audit Status',
  'pages.zy-crm.quote.field.discountPercent': 'Discount (%)',
  'pages.zy-crm.quote.field.totalProductPrice': 'Total Product Cost',
  'pages.zy-crm.quote.field.totalPrice': 'Quote Amount',
  'pages.zy-crm.quote.field.profitAmount': 'Profit',
  'pages.zy-crm.quote.field.remark': 'Remark',
  'pages.zy-crm.quote.field.sourceQuoteUuid': 'Source Quote',
  'pages.zy-crm.quote.field.products': 'Products',
  'pages.zy-crm.quote.field.productName': 'Product Name',
  'pages.zy-crm.quote.field.productType': 'Product Type',
  'pages.zy-crm.quote.field.productUnit': 'Unit',
  'pages.zy-crm.quote.field.listPrice': 'List Price',
  'pages.zy-crm.quote.field.costPrice': 'Cost Price',
  'pages.zy-crm.quote.field.salePrice': 'Sale Price',
  'pages.zy-crm.quote.field.quantity': 'Quantity',
  'pages.zy-crm.quote.field.lineTotal': 'Line Total',
  'pages.zy-crm.quote.field.historyRange': 'Time Range',
  'pages.zy-crm.quote.field.historyKeyword': 'Keyword',
  'pages.zy-crm.quote.field.dateFormat': 'Date Format',
  'pages.zy-crm.quote.field.resetCycle': 'Reset Cycle',
  'pages.zy-crm.quote.field.seqLength': 'Sequence Length',
  'pages.zy-crm.quote.field.prefix': 'Prefix',
  'pages.zy-crm.followUps.title': 'Follow Up Records',
  'pages.zy-crm.invoice.title': 'Invoices',
  'pages.zy-crm.invoice.detailTitle': 'Invoice Detail',
  'pages.zy-crm.invoice.action.refresh': 'Refresh',
  'pages.zy-crm.invoice.action.create': 'New Invoice',
  'pages.zy-crm.invoice.action.detail': 'Detail',
  'pages.zy-crm.invoice.action.edit': 'Edit',
  'pages.zy-crm.invoice.action.delete': 'Delete',
  'pages.zy-crm.invoice.action.submit': 'Submit',
  'pages.zy-crm.invoice.action.addItem': 'Add Item',
  'pages.zy-crm.invoice.action.back': 'Back to List',
  'pages.zy-crm.invoice.action.save': 'Save',
  'pages.zy-crm.invoice.action.cancel': 'Cancel',
  'pages.zy-crm.invoice.action.manageProfile': 'Manage Profiles',
  'pages.zy-crm.invoice.action.selectProfile': 'Select Invoice Profile',
  'pages.zy-crm.invoice.modal.createTitle': 'Create Invoice',
  'pages.zy-crm.invoice.modal.editTitle': 'Edit Invoice',
  'pages.zy-crm.invoice.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.invoice.modal.deleteContent': 'This action cannot be undone.',
  'pages.zy-crm.invoice.column.operation': 'Actions',
  'pages.zy-crm.invoice.search.expand': 'Expand',
  'pages.zy-crm.invoice.search.collapse': 'Collapse',
  'pages.zy-crm.invoice.form.group.basic': 'Basic Information',
  'pages.zy-crm.invoice.form.group.invoice': 'Invoice Information',
  'pages.zy-crm.invoice.form.placeholder.input': 'Please enter {label}',
  'pages.zy-crm.invoice.form.placeholder.select': 'Please select {label}',
  'pages.zy-crm.invoice.form.required': 'Required field',
  'pages.zy-crm.invoice.message.createSuccess': 'Created successfully',
  'pages.zy-crm.invoice.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.invoice.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.invoice.message.submitSuccess': 'Submitted successfully',
  'pages.zy-crm.invoice.message.detailLoadFailed': 'Failed to load detail',
  'pages.zy-crm.invoice.message.profileRequired':
    'Please select invoice information',
  'pages.zy-crm.invoice.message.manualSnapshotRequired':
    'Please enter title type, invoice title and tax number',
  'pages.zy-crm.invoice.message.contractRequired':
    'Please select a contract first',
  'pages.zy-crm.invoice.message.itemsRequired':
    'Please add at least one invoice item',
  'pages.zy-crm.invoice.member.unknown': 'Unknown member',
  'pages.zy-crm.invoice.state.missingUuid': 'Missing uuid parameter',
  'pages.zy-crm.invoice.state.detailNotFound': 'Detail not found',
  'pages.zy-crm.invoice.state.emptyItems': 'No data',
  'pages.zy-crm.invoice.state.relationDataEmpty':
    'Related data can be supplemented by business APIs',
  'pages.zy-crm.invoice.placeholder.autoCode':
    'Generated automatically by code rules',
  'pages.zy-crm.invoice.field.code': 'Invoice Request No.',
  'pages.zy-crm.invoice.field.customerUuid': 'Customer',
  'pages.zy-crm.invoice.field.customerName': 'Customer Name',
  'pages.zy-crm.invoice.field.contractUuid': 'Contract',
  'pages.zy-crm.invoice.field.contractName': 'Contract Name',
  'pages.zy-crm.invoice.field.ownerUserUuid': 'Owner',
  'pages.zy-crm.invoice.field.invoiceDate': 'Invoice Date',
  'pages.zy-crm.invoice.field.invoiceType': 'Invoice Type',
  'pages.zy-crm.invoice.field.auditStatus': 'Status',
  'pages.zy-crm.invoice.field.processInstanceUuid': 'Process Instance',
  'pages.zy-crm.invoice.field.invoiceProfileName': 'Invoice Title Profile',
  'pages.zy-crm.invoice.field.totalAmount': 'Invoice Amount',
  'pages.zy-crm.invoice.field.remark': 'Remark',
  'pages.zy-crm.invoice.field.invoiceProfileUuid': 'Invoice Profile',
  'pages.zy-crm.invoice.field.titleType': 'Title Type',
  'pages.zy-crm.invoice.field.titleSnapshot': 'Invoice Title',
  'pages.zy-crm.invoice.field.taxNoSnapshot': 'Tax No.',
  'pages.zy-crm.invoice.field.bankNameSnapshot': 'Bank',
  'pages.zy-crm.invoice.field.bankAccountSnapshot': 'Bank Account',
  'pages.zy-crm.invoice.field.addressSnapshot': 'Address',
  'pages.zy-crm.invoice.field.phoneSnapshot': 'Phone',
  'pages.zy-crm.invoice.field.saveAsProfile': 'Save as common invoice profile',
  'pages.zy-crm.invoice.field.mailContact': 'Contact',
  'pages.zy-crm.invoice.field.mailPhone': 'Contact Phone',
  'pages.zy-crm.invoice.field.mailAddressRegion': 'Mailing Region',
  'pages.zy-crm.invoice.field.mailAddressDetail': 'Detailed Address',
  'pages.zy-crm.invoice.field.items': 'Invoice Items',
  'pages.zy-crm.invoice.section.items': 'Receipt Items',
  'pages.zy-crm.invoice.field.receiptCode': 'Receipt No.',
  'pages.zy-crm.invoice.field.receiptScheduleCode': 'Receipt Schedule No.',
  'pages.zy-crm.invoice.field.contractCode': 'Contract No.',
  'pages.zy-crm.invoice.field.contractAmount': 'Contract Amount',
  'pages.zy-crm.invoice.field.uninvoicedAmount': 'Uninvoiced Amount',
  'pages.zy-crm.invoice.field.invoiceAmount': 'Current Invoice Amount',
  'pages.zy-crm.invoice.field.receiptDate': 'Receipt Date',
  'pages.zy-crm.invoice.field.receiptMethod': 'Receipt Method',
  'pages.zy-crm.invoice.field.createdAt': 'Created At',
  'pages.zy-crm.invoice.option.type.normal': 'Normal Invoice',
  'pages.zy-crm.invoice.option.type.special': 'Special Invoice',
  'pages.zy-crm.invoice.option.title.company': 'Company',
  'pages.zy-crm.invoice.option.title.personal': 'Personal',
  'pages.zy-crm.invoice.option.status.draft': 'Draft',
  'pages.zy-crm.invoice.option.status.pending': 'Pending',
  'pages.zy-crm.invoice.option.status.approved': 'Approved',
  'pages.zy-crm.invoice.option.status.rejected': 'Rejected',
  'pages.zy-crm.invoice.section.mailing': 'Mailing Information',
  'pages.zy-crm.invoice.card.invoiceInfo': 'Invoice Information',
  'pages.zy-crm.invoice.card.mailing': 'Mailing Information',
  'pages.zy-crm.invoice-profile.title': 'Invoice Profile Management',
  'pages.zy-crm.invoice-profile.action.refresh': 'Refresh',
  'pages.zy-crm.invoice-profile.action.create': 'New Invoice Profile',
  'pages.zy-crm.invoice-profile.action.edit': 'Edit',
  'pages.zy-crm.invoice-profile.action.delete': 'Delete',
  'pages.zy-crm.invoice-profile.column.operation': 'Actions',
  'pages.zy-crm.invoice-profile.modal.createTitle': 'Create Invoice Profile',
  'pages.zy-crm.invoice-profile.modal.editTitle': 'Edit Invoice Profile',
  'pages.zy-crm.invoice-profile.modal.deleteTitle': 'Confirm Delete',
  'pages.zy-crm.invoice-profile.modal.deleteContent':
    'This action cannot be undone.',
  'pages.zy-crm.invoice-profile.form.required': 'Required field',
  'pages.zy-crm.invoice-profile.message.createSuccess': 'Created successfully',
  'pages.zy-crm.invoice-profile.message.updateSuccess': 'Updated successfully',
  'pages.zy-crm.invoice-profile.message.deleteSuccess': 'Deleted successfully',
  'pages.zy-crm.invoice-profile.message.detailLoadFailed':
    'Failed to load detail',
  'pages.zy-crm.invoice-profile.field.name': 'Profile Name',
  'pages.zy-crm.invoice-profile.field.type': 'Title Type',
  'pages.zy-crm.invoice-profile.field.title': 'Invoice Title',
  'pages.zy-crm.invoice-profile.field.taxNo': 'Tax No.',
  'pages.zy-crm.invoice-profile.field.bankName': 'Bank',
  'pages.zy-crm.invoice-profile.field.bankAccount': 'Bank Account',
  'pages.zy-crm.invoice-profile.field.address': 'Address',
  'pages.zy-crm.invoice-profile.field.phone': 'Phone',
  'pages.zy-crm.invoice-profile.field.isDefault': 'Default',
  'pages.zy-crm.invoice-profile.field.remark': 'Remark',
  'pages.zy-crm.invoice-profile.field.createdAt': 'Created At',
  'pages.zy-crm.invoice-profile.option.boolean.yes': 'Yes',
  'pages.zy-crm.invoice-profile.option.boolean.no': 'No',
  'pages.zy-crm.contactOpportunity.field.status': 'Status',
};
